import React, { useState, useEffect } from 'react';
import MemberCard from '../components/MemberCard';
import { membersAPI } from '../services/api';

const Members = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState('All');

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await membersAPI.getAll();
      setMembers(response.data);
    } catch (error) {
      console.error('Error fetching members:', error);
    } finally {
      setLoading(false);
    }
  };

  // Group members by country
  const membersByCountry = members.reduce((acc, member) => {
    if (!acc[member.country]) {
      acc[member.country] = [];
    }
    acc[member.country].push(member);
    return acc;
  }, {});

  const countries = ['All', ...Object.keys(membersByCountry).sort()];
  
  const filteredMembers = selectedCountry === 'All' 
    ? members 
    : membersByCountry[selectedCountry] || [];

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white text-xl">Loading community members...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-red-500 to-red-700 bg-clip-text text-transparent mb-4">
            Our Global Community
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Meet our amazing players from around the world
          </p>
        </div>

        {members.length > 0 && (
          <>
            {/* Country Filter */}
            <div className="mb-8">
              <div className="flex flex-wrap justify-center gap-2">
                {countries.map((country) => (
                  <button
                    key={country}
                    onClick={() => setSelectedCountry(country)}
                    className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 ${
                      selectedCountry === country
                        ? 'bg-gradient-to-r from-red-600 to-red-800 text-white shadow-lg'
                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white border border-gray-600'
                    }`}
                  >
                    {country}
                    {country !== 'All' && (
                      <span className="ml-2 bg-red-600 text-white text-xs px-2 py-1 rounded-full">
                        {membersByCountry[country]?.length || 0}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Members Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredMembers.map((member) => (
                <MemberCard key={member.id} member={member} />
              ))}
            </div>

            {filteredMembers.length === 0 && selectedCountry !== 'All' && (
              <div className="text-center py-12">
                <div className="bg-gradient-to-r from-gray-800/50 to-gray-700/50 rounded-2xl p-8 border border-gray-600/30 backdrop-blur-sm">
                  <h3 className="text-xl font-bold text-white mb-2">No members found</h3>
                  <p className="text-gray-400">
                    No members from {selectedCountry} yet. Be the first to join!
                  </p>
                </div>
              </div>
            )}
          </>
        )}

        {members.length === 0 && (
          <div className="text-center py-12">
            <div className="bg-gradient-to-r from-gray-800/50 to-gray-700/50 rounded-2xl p-8 border border-gray-600/30 backdrop-blur-sm">
              <h3 className="text-xl font-bold text-white mb-2">No members yet</h3>
              <p className="text-gray-400">
                Be the first to join our amazing community!
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Members;